import React from 'react';
import { apiConfig } from '../../../config/api';
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Copy } from "lucide-react";
import { useToast } from '@/components/ui/use-toast';

interface FormTagSectionProps {
  apiKey: string;
}

const FormTagSection: React.FC<FormTagSectionProps> = ({ apiKey }) => {
  const { toast } = useToast();
  
  const formTagSample = `<form id="contact-form">
  <div>
    <label>お名前</label>
    <input type="text" name="name" required>
  </div>

  <div>
    <label>メールアドレス</label>
    <input type="email" name="email" required>
  </div>

  <div>
    <label>お問い合わせ内容</label>
    <textarea name="content" required></textarea>
  </div>

  <button type="submit">送信</button>
</form>
<script 
  id="conta-kun-form"
  src="${apiConfig.staticEndpoint}/form.js"
  data-api-key="${apiKey}">
</script>`;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(formTagSample);
      toast({
        title: "コピーしました"
      });
    } catch {
      toast({
        title: "コピーに失敗しました",
        variant: "destructive"
      });
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex justify-between items-center">
          ミニマムサンプル
          <Button
            variant="outline"
            size="sm"
            onClick={handleCopy}
          >
            <Copy className="w-4 h-4 mr-2" />
            Copy
          </Button>
        </CardTitle>
      </CardHeader>
      <CardContent className="text-left">
        <pre className="bg-gray-50 p-4 rounded-lg overflow-x-auto text-xs">
          <code>{formTagSample}</code>
        </pre>
      </CardContent>
    </Card>
  );
};

export default FormTagSection;
